class SelectContentChange {
  constructor(element$) {
    this._element$ = element$;
    this._select$  = this._element$.find('select');

    this._select$.on('change', this.onChange.bind(this));
  }

  onChange() {
    this._element$.find('.tab-pane.active[data-voc-sportsdata-select-content-change-panel]').removeClass('active');
    this._element$.find(`[data-voc-sportsdata-select-content-change-panel="${this._select$.val()}"]`).addClass('active');
  }
}

export default SelectContentChange;



// WEBPACK FOOTER //
// ./src/views/select-content-change.js